import React from 'react';
import styled from 'styled-components/macro';
import ProgressBar from './ProgressBar';
import { getPasswordStrength } from '../../utils';
import { passwordStrengthLabels, passwordStrengthColors } from './config';
import HoverInfoText from '../HoverInfoText';
import { passwordRequirements } from '@as_core/account/forms/config';

interface propsT {
  password: string;
}

const PasswordStrengthBar = (props: propsT) => {
  const { password } = props;
  const strength = getPasswordStrength(password).strength;

  return (
    <PasswordStrengthBarContainer>
      <PasswordLabel>{passwordStrengthLabels[strength]}</PasswordLabel>
      <PasswordBar>
        <ProgressBar
          bars={5}
          level={strength}
          color={passwordStrengthColors[strength]}
        />
      </PasswordBar>
      <PasswordInfoHolder>
        <HoverInfoText text={passwordRequirements} />
      </PasswordInfoHolder>
    </PasswordStrengthBarContainer>
  );
};

export default PasswordStrengthBar;

const PasswordStrengthBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  justify-content: center;
  height: 24px;
`;

const PasswordLabel = styled.div`
  display: flex;
  font-size: 11px;
  color: ${(p) => p.theme.palette.textSecondary};
  position: absolute;
  left: 0;
`;

const PasswordBar = styled.div`
  display: flex;
  width: 65%;
  align-items: center;
  justify-content: center;
`;

const PasswordInfoHolder = styled.div`
  position: absolute;
  right: 0;
`;
